export function tableWindow(total, scrollTop, height, rowHeight = 40, overscan = 10) {
  const start = Math.max(0, Math.min(total, Math.floor(Math.max(0, scrollTop - 40) / rowHeight) - overscan));
  const end = Math.min(total, start + Math.ceil(Math.max(0, height) / rowHeight) + overscan * 2);
  return { start, end, before: start * rowHeight, after: (total - end) * rowHeight };
}
